class MorningStartService {
  public async handler() {
    const clientIdentifier = '8WOC44ZC9ODCQkHCisyzyOrwcTm4g5eJ';
    const clientSecret = 'v2DOwfKNQJNmoEyC';
    const url = 'https://www.emea-api.morningstar.com/token/oauth';

    const authHeader =
      'Basic ' + Buffer.from(`${clientIdentifier}:${clientSecret}`).toString('base64');

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: authHeader,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const tokenResponse = await response.json();

      if ('access_token' in tokenResponse) {
        return {
          access_token: tokenResponse.access_token,
        };
      }
    } catch (error) {
      console.error('Access token not found!');
    }
  }
}

export const morningStarService = new MorningStartService();
